var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sidebar-error"},[_c('Heading',{staticClass:"sidebar-error__heading",attrs:{"level":3}},[_vm._v(" "+_vm._s(_vm.sectionTitle)+" ")]),_c('ErrorHandler',{attrs:{"title":_vm.errorTitle,"description":_vm.errorDescription},on:{"retry":_vm.emitRetry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }